export const allowedToEditPriceList = [
  "kaoutar.afkir@gmail.com",
  // "jassim.joy12@hotmail.com",
  "khaialpearly@ymail.com",
  "reviewer@sal125.com",
  "admin@admin.com",
  "mostafa11.mm6@gmail.com",
  "autoaitesting@gmail.com"
];
